import React from 'react';
import {
  ActionText,
  CardHeaderWrap,
  DashboardCardWrap,
  ScrollableContent,
} from './components/dashboardStyled';
import Grid from '@mui/material/Grid';
import MDTypography from 'components/MDTypography';
import RedesignedStatsCard from './components/RedesignedStatsCard';

export const cardListColors = ['#4CAF50', '#2196F3', '#fb8c00', '#f44336', '#9c27b0'];

/**
 * Renders a standard statistics card within a Grid item.
 */
export const RenderStatsCard = ({ stat }) => (
  <Grid item xs={12} sm={6}>
    <RedesignedStatsCard
      variant="plain"
      icon={stat.icon}
      title={stat.title}
      count={stat.count || 0}
    />
  </Grid>
);

/**
 * Renders a small info stat card within a Grid item.
 */
export const RenderInfoStat = ({ info }) => (
  <Grid item xs={12} sm={6} md={3}>
    <RedesignedStatsCard
      variant="small"
      icon={info.icon}
      title={info.title}
      count={info.count || (info.title.includes('Check') ? 'N/A' : 0)}
    />
  </Grid>
);

/**
 * Renders a lower dashboard card (Tasks, Assets, Locations) within a Grid item.
 */
export const RenderLowerCard = ({ card }) => (
  <Grid item xs={12} md={4}>
    <DashboardCardWrap height="35vh">
      <CardHeaderWrap>
        <MDTypography variant="button" fontWeight="bold">
          {card.title}
        </MDTypography>
        {card.isNavigate && <ActionText variant="button" color="info" onClick={card.action}>
          View all →
        </ActionText>}
      </CardHeaderWrap>
      <ScrollableContent>{card.component}</ScrollableContent>
    </DashboardCardWrap>
  </Grid>
);
